import { NgModule } from 'ng-metadata/core';
import { CheckoutCartComponent } from './cart.component';
import { CheckoutCartItemModule } from './item/cart-item.module';

@NgModule({
  imports: [
    CheckoutCartItemModule,
  ],
  declarations: [
    CheckoutCartComponent,
  ],
})
export class CheckoutCartModule { }



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/cart/cart.module.ts